import { useRef } from "react";
import { useFormContext } from "react-hook-form";
import mergeRefs from "react-merge-refs";

const CalendarField = ({
  name,
  defaultValue,
}: {
  name: string;
  defaultValue?: string;
}) => {
  const { register } = useFormContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    inputRef.current?.focus();
    inputRef.current?.showPicker();
  };
  return (
    <input
      {...register(name, { value: defaultValue })}
      ref={mergeRefs([register(name).ref, inputRef])}
      onClick={handleClick}
      className="flex-1 rounded-md h-9 px-[0.625rem] bg-white flex justify-between items-center text-14"
      type="date"
    />
  );
};

export default CalendarField;
